(function (root) {
  'use strict';

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function fieldsFor(item, source) {
    var id = String(item.product_id || (item.product && item.product.id) || '');
    var assignment = source && source.productOptionSetMap && source.productOptionSetMap[id];
    var sets = Array.isArray(assignment) ? assignment : String(assignment || '').split(',');
    var fields = [];
    function walk(elements) {
      if (!Array.isArray(elements)) return;
      elements.forEach(function (element) {
        if (Array.isArray(element.elements)) {
          walk(element.elements);
        } else if (element.label_on_cart && !/^(paragraph|heading|html|divider|spacing|tabs|popup|sizechart|size-chart)$/i.test(element.type || '')) {
          fields.push({
            key: String(element.label_on_cart),
            label: String(element.label || element.label_on_cart).replace(/<[^>]*>/g, '').trim(),
            kind: element.type === 'file' ? 'file' : 'text'
          });
        }
      });
    }
    sets.forEach(function (set) {
      var option = source && source.options && source.options[String(set).trim()];
      if (option) walk(option.elements);
    });
    return fields;
  }

  function safeUrl(value) {
    if (!/^https:\/\/[^\s]+$/i.test(value)) return null;
    try { return new URL(value).protocol === 'https:' ? value : null; } catch (error) { return null; }
  }

  function rows(item, source) {
    var fields = fieldsFor(item, source);
    var result = [];
    Object.entries(item.properties || {}).forEach(function (entry, position) {
      var key = entry[0];
      if (key.charAt(0) === '_' || entry[1] === null || entry[1] === undefined || entry[1] === '') return;
      var candidates = fields.filter(function (field) { return field.key === key; });
      if (!candidates.length) {
        candidates = fields.filter(function (field) {
          return field.kind === 'file' && key.indexOf(field.key + '-') === 0 && /^[1-9][0-9]*$/.test(key.slice(field.key.length + 1));
        });
      }
      var labels = [];
      candidates.forEach(function (field) { if (labels.indexOf(field.label) === -1) labels.push(field.label); });
      var value = String(entry[1]);
      result.push({
        key: key,
        label: labels.length ? labels.join(' / ') : key.replace(/[-_]/g, ' '),
        value: value,
        href: safeUrl(value),
        file: candidates.length > 0 && candidates.every(function (field) { return field.kind === 'file'; }),
        unmapped: !candidates.length,
        ambiguous: labels.length > 1,
        rank: candidates.length ? fields.indexOf(candidates[0]) : fields.length,
        position: position
      });
    });
    return result.sort(function (a, b) { return a.rank - b.rank || a.position - b.position; });
  }

  function content(item, source, ui) {
    var properties = rows(item, source);
    if (!properties.length) return '';
    return '<dl class="ens-personalisation-summary">' + properties.map(function (property) {
      var flag = property.unmapped ? ' data-ens-unmapped-property="' + escapeHtml(property.key) + '"' : '';
      if (property.ambiguous) flag += ' data-ens-ambiguous-property="' + escapeHtml(property.key) + '"';
      var value = property.href
        ? '<a href="' + escapeHtml(property.href) + '" target="_blank" rel="noopener">' + escapeHtml(property.file ? ui.viewFile : property.value) + '</a>'
        : '<span class="ens-personalisation-summary__value">' + escapeHtml(property.value) + '</span>';
      return '<div class="ens-personalisation-summary__row"' + flag + '><dt>' + escapeHtml(property.label) + ':</dt><dd>' + value + '</dd></div>';
    }).join('') + '</dl>';
  }

  function render(item, source, ui) {
    var data = { product_id: item.product_id || (item.product && item.product.id), properties: item.properties || {} };
    return '<div data-ens-personalisation-item="' + escapeHtml(JSON.stringify(data)) + '">' + content(data, source, ui || {}) + '</div>';
  }

  var api = { rows: rows, render: render, fieldsFor: fieldsFor };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root && root.document) {
    var element = root.document.getElementById('ens-personalisation-summary-config');
    var ui = {};
    if (element) {
      try { ui = JSON.parse(element.textContent); } catch (error) { ui = {}; }
    }
    root.theme = root.theme || {};
    var cartItems = new Map();
    root.theme.ensPersonalisationSummary = {
      render: function (item) { return render(item, root.GPOConfigs, ui); },
      updateCart: function (cart) {
        cartItems.clear();
        (cart.items || []).forEach(function (item) { cartItems.set(item.key, item); });
        hydrate();
      }
    };
    var rendered = new WeakMap();
    function hydrate() {
      root.document.querySelectorAll('[data-ens-personalisation-item]').forEach(function (node) {
        try {
          var lineKey = node.getAttribute('data-ens-cart-line-key');
          if (lineKey && !cartItems.has(lineKey)) return;
          var item = lineKey ? cartItems.get(lineKey) : JSON.parse(node.getAttribute('data-ens-personalisation-item'));
          var html = content(item, root.GPOConfigs, ui);
          if (rendered.get(node) !== html) {
            rendered.set(node, html);
            if (lineKey) node.setAttribute('data-ens-personalisation-item', JSON.stringify({ product_id: item.product_id, properties: item.properties || {} }));
            node.innerHTML = html;
          }
        } catch (error) { return; }
      });
    }
    var queued = false;
    var observer = new MutationObserver(function (records) {
      var added = records.some(function (record) {
        return Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('[data-ens-personalisation-item]') || node.querySelector('[data-ens-personalisation-item]'));
        });
      });
      if (queued || !added) return;
      queued = true;
      root.queueMicrotask(function () { queued = false; hydrate(); });
    });
    function start() {
      hydrate();
      observer.observe(root.document.body, { childList: true, subtree: true });
      var attempts = 0;
      function retry() {
        hydrate();
        if ((!root.GPOConfigs || !root.GPOConfigs.productOptionSetMap || !root.GPOConfigs.options) && ++attempts < 20) root.setTimeout(retry, 500);
      }
      retry();
    }
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
    root.addEventListener('load', hydrate, { once: true });
    root.document.addEventListener('shopify:section:load', hydrate);
  }
})(typeof window === 'undefined' ? null : window);
